import client from "../libs/HttpClient";

class BrochureService {
  static getBrochureData() {
    return client.get("/brochure");
  }
}

export { BrochureService };
